export default "__VITE_ASSET__DScXuezn__"